import { containerOrder } from "./containerOrder";
import { generalFreightOrder } from "./generalFreightOrder";

const containerTransportOrder = {
	...containerOrder,
	...generalFreightOrder
};

export { containerTransportOrder };
